import * as _ from 'lodash-es';
import {Observable, of} from 'rxjs';
import {AutocompleteProvider} from './autocomplete-config';

/**
 * Autocomplete provider for a defined variant list.
 *
 * Usage:
 * autocompleteConfig: AutocompleteConfig = {
 *   type: new DefinedListAutocompleteService({list: ['item1', 'item2']}),
 *   freeTyping: false,
 *   allowVariantOrNull: true
 * };
 */
export class DefinedListAutocompleteService<T> implements AutocompleteProvider<T> {

    /**
     * List of all variants.
     */
    public list: T[] = [];

    /**
     * Optional inner property of the item by which to filter.
     */
    public filterByField: keyof T;

    constructor(options?: {list?: T[]; filterByField?: keyof T}) {
        Object.assign(this, options);
    }

    public autocomplete(term: string): Observable<T[]> {
        const filteredList = this.filter(this.list, term);

        return of(filteredList);
    }

    public filter(list: T[], term: string): T[] {
        return _.filter(list, item => this.match(item, term));
    }

    public match(item: T, term: string): boolean {
        const value = (this.getPrimitiveValue(item) + '')
            .toLocaleUpperCase();

        return value.indexOf(term.toLocaleUpperCase()) >= 0;
    }

    public getPrimitiveValue(item: T): string {
        return (
            !this.filterByField ? item : item[this.filterByField]
        ) + '';
    }

    public setList(list: T[]): void {
        this.list = list;
    }
}
